import { Elements } from '@stripe/react-stripe-js';
import { Appearance, loadStripe, Stripe, StripeElementsOptions } from '@stripe/stripe-js';
import { IPaymentSetupData } from 'fitbeat.models';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { getStripePublishableKey } from '../../config';
import Theme from '../../theme';
import { StripePaymentElement } from './StripePaymentElement';

interface IProps {
  t: (key: string, options?: any) => string;
  paymentSetupData: null | IPaymentSetupData;
  stripeCustomerId: string;
  userId: string;
  paymentMethodAdded?: () => void;
}

export const StripePaymentElementProvider: FunctionComponent<IProps> = (
  {
    t,
    paymentSetupData,
    stripeCustomerId,
    userId,
  },
) => {

  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);

  useEffect(() => {
    if (paymentSetupData && paymentSetupData.accountId && !stripePromise) {
      setStripePromise(loadStripe(getStripePublishableKey(), { stripeAccount: paymentSetupData.accountId }));
    }
  }, [paymentSetupData]);

  const appearance: Appearance = {
    theme: 'stripe',
    variables: {
      fontFamily: ' "Barlow", sans-serif',
      colorBackground: Theme.GREY_LIGHT,
      colorDanger: Theme.RED,
      fontSizeBase: '16px',
      borderRadius: '3px',
      colorTextPlaceholder: Theme.GREY_MEDIUM,
    },
    rules: {
      '.Input': {
        border: 'none',
      },
      '.Label': {
        color: Theme.GREY,
        fontSize: '12px',
      },
    },
  };

  const options: StripeElementsOptions = {
    clientSecret: (paymentSetupData && paymentSetupData.clientSecret) ? paymentSetupData.clientSecret : '',
    appearance,
  };

  return (
    <div>
      {
        paymentSetupData && stripePromise && paymentSetupData.returnUrl &&
        <Elements options={options} stripe={stripePromise}>
          <StripePaymentElement t={t} returnUrl={paymentSetupData.returnUrl}
                                stripeCustomerId={stripeCustomerId} userId={userId} />
        </Elements>
      }
    </div>
  );
};
